import { format, parseISO } from "date-fns";

import {
  BenefitTypeEnum,
  ItemStatusEnum,
} from "../../api/payments/items/domain/enum";

export function normalizeStatus(value) {
  return value ? String(value).toUpperCase() : ItemStatusEnum.INACTIVE;
}

export function normalizeBenefitType(value) {
  return value ? String(value).toUpperCase() : BenefitTypeEnum.CREDITS;
}

export const formatCreatedAt = (createdAt) => {
  if (!createdAt) {
    return "Sem data";
  }

  return format(parseISO(createdAt), "dd/MM/yyyy");
};

export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

export const parseDisplayClient = (value) => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    return normalized === "true" || normalized === "1";
  }

  return false;
};

export const buildItemsQueryParams = ({
  page,
  limit,
  filterText,
  sortBy = "createdAt",
  sortOrder = "desc",
}) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    sortBy,
    sortOrder,
  });

  const normalizedFilterText = String(filterText || "").trim();

  if (normalizedFilterText) {
    params.append("search", normalizedFilterText);
  }

  return params;
};

export function extractItems(response) {
  const payload = response.data?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.content)) return payload.content;
  if (Array.isArray(payload?.data)) return payload.data;
  return response.data?.content || [];
}
